module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-light-blue.46701216.svg";